import React, { useEffect, useState } from "react";
import useCities from "../Hooks/useCities";
import CitySelect from "./CitySelect";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";

const CheckoutForm = ({
  formData,
  handleInputChange,
  handleSubmit,
  saveInfo,
  setSaveInfo,
  setShipping,
  setFormData
}) => {
  const { cities, loading, error } = useCities()
  const [isSameAddress, setIsSameAddress] = useState(true);
  const [captchaToken, setCaptchaToken] = useState(null);
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };
  const handleBillingToggle = (e) => {
    const isSame = e.target.value === "same_as_shipping";
    setIsSameAddress(isSame);
    handleInputChange({
      target: { name: "billing_address", value: e.target.value },
    });
    if(!isSame){
      setFormData((prevState) => ({
        ...prevState,
        billing_address: e.target.value,
        billing_address_first_name: "",
        billing_address_last_name: "",
        billing_address_address: "",
        billing_city: "",
        billing_postal_code: "",
        billing_phone: "",
      }));
    }
    
  };
  const handleInnerForm = (e) =>{
    e.preventDefault();
    if (!captchaToken) {
      toast.error("Please complete the captcha verification.");
      return;
    }
    if (isSameAddress) {
      setFormData((prevState) => ({
        ...prevState,
        billing_address: prevState.address,
        billing_address_first_name: prevState.first_name,
        billing_address_last_name: prevState.last_name,
        billing_address_address: prevState.address,
        billing_city: prevState.city,
        billing_postal_code: prevState.postal_code,
        billing_phone: prevState.phone,
      }));
    }
    handleSubmit(e)
  }
  return (
    <div>
      <form onSubmit={handleInnerForm} className="space-y-6">
        <h2 className="text-2xl font-bold">Contact</h2>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className="w-full border border-red-500 rounded-md p-2"
            required
          />
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            name="subscribe"
            onChange={handleInputChange}
            className="mr-2"
            style={{appearance:'auto'}}
          />
          <label>
            Click here to receive exclusive updates about products and offers
          </label>
        </div>

        <h2 className="text-2xl font-bold mt-8">Delivery</h2>

        {/* City Dropdown */}
        <CitySelect
          cities={cities}
          loading={loading}
          error={error}
          formData={formData}
          handleInputChange={handleInputChange}
          setShipping={setShipping}
        />

        {/* First Name */}
        <div>
          <label className="block text-sm font-medium">First Name</label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleInputChange}
            className="w-full border border-red-500 rounded-md p-2"
            required
          />
        </div>

        {/* Last Name */}
        <div>
          <label className="block text-sm font-medium">Last Name</label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleInputChange}
            className="w-full border border-red-500 rounded-md p-2"
            required
          />
        </div>

        {/* Address */}
        <div>
          <label className="block text-sm font-medium">Address</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            className="w-full border border-red-500 rounded-md p-2"
            required
          />
        </div>

        {/* Apartment (Optional) */}
        <div>
          <label className="block text-sm font-medium">
            Apartment, suite, etc. (optional)
          </label>
          <input
            type="text"
            name="apartment"
            value={formData.apartment}
            onChange={handleInputChange}
            className="w-full border border-gray-300 rounded-md p-2"
          />
        </div>

        {/* Postal Code */}
        <div>
          <label className="block text-sm font-medium">
            Postal Code (Optional)
          </label>
          <input
            type="text"
            name="postal_code"
            value={formData.postal_code}
            onChange={handleInputChange}
            className="w-full border border-gray-300 rounded-md p-2"
          />
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm font-medium">Phone</label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            placeholder="0300 0000000"
            className="w-full border border-red-500 rounded-md p-2"
            required
          />
        </div>

        <div className="flex items-center mt-4">
          <input
            type="checkbox"
            checked={saveInfo}
            onChange={(e) => setSaveInfo(e.target.checked)}
            className="mr-2"
            style={{appearance:'auto'}}
          />
          <label>Save this information for next time</label>
        </div>

        <h2 className="text-2xl font-bold mt-8">Payment Method</h2>
        <div className="space-y-4">
          <div className="flex items-center">
            <input
              type="radio"
              name="payment_method"
              value="cash_on_delivery"
              required={true}
              onChange={handleInputChange}
              className="mr-2"
            />
            <label>Cash on Delivery</label>
          </div>
          {/* <div className="flex items-center">
            <input
              type="radio"
              name="payment_method"
              value="credit_card"
              onChange={handleInputChange}
              className="mr-2"
            />
            <label>Credit Card</label>
          </div>
          <div className="flex items-center">
            <input
              type="radio"
              name="payment_method"
              value="bank_transfer"
              onChange={handleInputChange}
              className="mr-2"
            />
            <label>Bank Transfer</label>
          </div> */}
        </div>
        <h2 className="text-2xl font-bold">Billing Address</h2>

        <div className="space-y-2">
          <label className="block text-sm font-medium">
            Billing Address Options
          </label>
          <div className="flex items-center">
            <input
              type="radio"
              name="billing_address_option"
              value="same_as_shipping"
              checked={isSameAddress}
              onChange={handleBillingToggle}
              className="mr-2"
            />
            <label>Same as shipping address</label>
          </div>
          <div className="flex items-center">
            <input
              type="radio"
              name="billing_address_option"
              value="different_billing"
              checked={!isSameAddress}
              onChange={handleBillingToggle}
              className="mr-2"
            />
            <label>Use a different billing address</label>
          </div>
        </div>

        {!isSameAddress && (
          <div className="mt-4 space-y-4">
            {/* Country */}
            {/* <div>
              <label className="block text-sm font-medium">
                Country/Region
              </label>
              <input
                type="text"
                name="billing_address_country"
                value={formData.billing_address_country}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2"
                required
              />
            </div> */}

            {/* First Name */}
            <div>
              <label className="block text-sm font-medium">First Name</label>
              <input
                type="text"
                name="billing_address_first_name"
                value={formData.billing_address_first_name}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2"
                required
              />
            </div>

            {/* Last Name */}
            <div>
              <label className="block text-sm font-medium">Last Name</label>
              <input
                type="text"
                name="billing_address_last_name"
                value={formData.billing_address_last_name}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2"
                required
              />
            </div>

            {/* Address */}
            <div>
              <label className="block text-sm font-medium">Address</label>
              <input
                type="text"
                name="billing_address_address"
                value={formData.billing_address_address}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2"
                required
              />
            </div>

            {/* City */}
            <div>
              <label className="block text-sm font-medium">City</label>
              <input
                type="text"
                name="billing_city"
                value={formData.billing_city}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2"
                required
              />
            </div>

            {/* Postal Code */}
            <div>
              <label className="block text-sm font-medium">Postal Code</label>
              <input
                type="text"
                name="billing_postal_code"
                value={formData.billing_postal_code}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2"
              />
            </div>

            {/* Phone */}
            <div>
              <label className="block text-sm font-medium">Phone</label>
              <input
                type="text"
                name="billing_phone"
                value={formData.billing_phone}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md p-2  "
              />
            </div>
          </div>
        )}
         {process.env.REACT_APP_RECAPTCHA_ENABLER === "true" ? (
          <div className="mb-4">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
            />
          </div>
          ):null}
        <button
          type="submit"
          className="w-full bg-black text-white py-2 px-4 rounded-md mt-4"
          disabled={loading}
        >
          {loading ? "Placing Order":"Submit"}
        </button>
      </form>
    </div>
  );
};

export default CheckoutForm;
